export default "__VITE_ASSET__Ciz_lJM5__"